<div class="Dialog">
  <mat-toolbar class="Dialog__header" color="primary">
    <h2 mat-dialog-title class="Dialog__title"><mat-icon>help_outline</mat-icon> {{ post?.title }}</h2>
    <span class="flex-1"></span>
    <button mat-icon-button type="button" (click)="dismiss()"><mat-icon>close</mat-icon></button>
  </mat-toolbar>

  <div mat-dialog-content class="Dialog__content" *ngIf="post">
    <div class="p-3">
      <app-content-view [content]="post.content | linkImages"></app-content-view>
    </div>

    <div class="flex flex-col p-3" *ngIf="post.media?.length">
      <h3 class="Content-label">Bifogade filer</h3>
      <mat-action-list dense>
        <button mat-list-item *ngFor="let media of post.media" (click)="viewFile(media)">
          <mat-icon matListItemIcon>file_present</mat-icon>
          <p matListItemTitle>{{ media.title }}</p>
        </button>
      </mat-action-list>
    </div>

    <div class="p-3">
      <mat-chip-listbox>
        <mat-chip-option color="primary" *ngFor="let tag of post.attrs('keyword')">{{ tag }}</mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
</div>
